import { TFunction } from 'i18next';
import {
  CONSIGNMENT_STATUS,
  type CancellationReason,
  type ConsignmentStatusAction,
  type ConsignmentStatusCode
} from '@/entities/consignments';

export const getCancelationReasons = (t: TFunction): { value: CancellationReason; label: string }[] => [
  { value: 'A', label: t('requestHistory.cancellationReason.A') },
  { value: 'L', label: t('requestHistory.cancellationReason.L') },
  { value: 'S', label: t('requestHistory.cancellationReason.S') },
  { value: 'E', label: t('requestHistory.cancellationReason.E') },
  { value: 'O', label: t('requestHistory.cancellationReason.O') }
];

export const getPriorityOptions = (t: TFunction): { value: string; label: string }[] => [
  { value: 'urgent', label: t('dispatchPriorityName.2') },
  { value: 'high', label: t('dispatchPriorityName.3') },
  { value: 'normal', label: t('dispatchPriorityName.4') },
  { value: 'low', label: t('dispatchPriorityName.5') }
];

export const getStatusNames = (t: TFunction): Record<ConsignmentStatusCode, string> => ({
  [CONSIGNMENT_STATUS.NR]: t('requestStatusName.NR'),
  [CONSIGNMENT_STATUS.AC]: t('requestStatusName.AC'),
  [CONSIGNMENT_STATUS.IP]: t('requestStatusName.IP'),
  [CONSIGNMENT_STATUS.OH]: t('requestStatusName.OH'),
  [CONSIGNMENT_STATUS.CA]: t('requestStatusName.CA'),
  [CONSIGNMENT_STATUS.CL]: t('requestStatusName.CL')
});

/** Menu labels of the status actions: the legacy consignment-list labels where they exist, the JSF status buttons otherwise. */
export const getStatusActionLabels = (t: TFunction): Record<ConsignmentStatusAction, string> => ({
  ACCEPT: t('newcmr.reqstatus.AC.icon.label'),
  SET_ON_HOLD: t('listaction.RQ.HOL'),
  CANCEL: t('listaction.RQ.CAN'),
  RESET: t('newcmr.reqstatus.PREV.icon.label')
});

/** Legacy `RequestBean.getNewStatusDialogTitle`. */
export const getStatusChangeTitles = (t: TFunction): Record<ConsignmentStatusAction, string> => ({
  ACCEPT: t('newcmr.reqstatus.AC.title.message'),
  SET_ON_HOLD: t('newcmr.reqstatus.OH.title.message'),
  CANCEL: t('newcmr.reqstatus.CA.title.message'),
  RESET: t('newcmr.reqstatus.PREV.title.message')
});

/** Legacy `RequestBean.getNewStatusDescription`: name and description of every status a change can lead to. */
export const getNewStatusDescriptions = (t: TFunction): Partial<Record<ConsignmentStatusCode, string>> => ({
  [CONSIGNMENT_STATUS.NR]: `${t('requestStatusName.NR')} - ${t('requestStatusDesc.NR')}`,
  [CONSIGNMENT_STATUS.AC]: `${t('requestStatusName.AC')} - ${t('requestStatusDesc.AC')}`,
  [CONSIGNMENT_STATUS.OH]: `${t('requestStatusName.OH')} - ${t('requestStatusDesc.OH')}`,
  [CONSIGNMENT_STATUS.CA]: `${t('requestStatusName.CA')} - ${t('requestStatusDesc.CA')}`
});
